<ca-modal-container
    [modalTitle]="(completedPercent === 100 ? 'CZI_CONVERSION.CONVERSION_DIALOG.SUCCESS_TITLE' : 'CZI_CONVERSION.CONVERSION_DIALOG.TITLE') | translate"
    (dismiss)="dismiss()"
>
    <div class="d-flex flex-column">
        <span [ngClass]="{ 'text-warning': isConversionCompleted() && failedConversionFiles.length > 0 }">{{
            (!isConversionCompleted() && completedPercent < 100
                ? 'CZI_CONVERSION.CONVERSION_DIALOG.MESSAGE_IN_PROGRESS'
                : completedPercent === 100
                  ? 'CZI_CONVERSION.CONVERSION_DIALOG.MESSAGE_SUCCESS'
                  : failedConversionFiles.length > 0
                    ? 'CZI_CONVERSION.CONVERSION_DIALOG.MESSAGE_FAILED'
                    : 'CZI_CONVERSION.CONVERSION_DIALOG.MESSAGE_SUCCESS'
            ) | translate
        }}</span>
        <span class="mt-3 label-text">{{
            isConversionCompleted() && failedConversionFiles.length === 0
                ? ('CZI_CONVERSION.CONVERSION_DIALOG.FINISHED_MESSAGE' | translate)
                : ('CZI_CONVERSION.CONVERSION_DIALOG.PROGRESS_MESSAGE' | translate: { completedPercent: completedPercent | percentage })
        }}</span>
        <div class="mt-2">
            <ca-ratio [value]="completedSize" [overallValue]="overallSizeOfOriginalFiles" [height]="24" data-uit="czi-conversion-progress"></ca-ratio>
        </div>
        <div class="d-flex flex-column mt-2">
            <div *ngIf="isConversionCompleted() && failedConversionFiles.length > 0" class="d-flex flex-column failed-conversion-files-cnt">
                <span>{{ 'CZI_CONVERSION.CONVERSION_DIALOG.FAILED_MESSAGE_DESCRIPTION' | translate }}</span>
                <ca-file-item
                    class="mt-2 text-warning"
                    *ngFor="let file of failedConversionFiles; let first = first"
                    [class.first]="first"
                    [file]="file"
                    [preview]="false"
                    [download]="true"
                    [removeFiles]="datasetId != null"
                    [useTrashIcon]="true"
                    (onRemoveSelection)="removeFile($event)"
                ></ca-file-item>
            </div>
            <div *ngIf="!isConversionCompleted()" class="d-flex mt-2">
                <ca-icon name="info" [removeSVGAttributes]="['stroke']" size="s" class="info-icon"></ca-icon
                ><span class="ms-2">{{
                    (isConversionCompleted()
                        ? 'CZI_CONVERSION.CONVERSION_DIALOG.CLOSE_MESSAGE'
                        : 'CZI_CONVERSION.CONVERSION_DIALOG.CLOSE_MESSAGE_CONVERSION_IN_PROGRESS'
                    ) | translate
                }}</span>
            </div>
        </div>
        <button
            *ngIf="isConversionCompleted() && failedConversionFiles.length > 0"
            type="button"
            class="btn btn-secondary mt-4"
            (click)="retry()"
            data-uit="czi-conversion-retry-btn"
        >
            {{
                (failedConversionFiles.length === 1 ? 'CZI_CONVERSION.RETRY' : 'CZI_CONVERSION.RETRY_PLURAL')
                    | translate: { numOfFiles: failedConversionFiles.length }
            }}
        </button>
        <button
            type="button"
            class="btn btn-primary mt-4"
            [disabled]="!isConversionCompleted() || failedConversionFiles.length > 0"
            (click)="next()"
            data-uit="czi-conversion-next-btn"
        >
            {{ 'GENERAL.NEXT' | translate }}
        </button>
    </div>
</ca-modal-container>
